import StaticTemplate from '../StaticTemplate';
import AboutUs from './AboutUs';
import OurSolutions from './OurSolutions';
import ContactUs from './ContactUs';
import Careers from './Careers';
import { getPageTitle } from '@/finsight/ui/common/helpers';
import URL from '@/finsight/Router/urlConstants';
import metaTags from '@/finsight/ui/common/metaTagsConstants';
import {
  getAboutPageMetaSchema,
  getSolutionPageMetaSchema,
  getContactUsPageMetaSchema,
  getCareersPageMetaSchema,
} from './getCompanyMetaSchemas';
import Pricing from '@/finsight/ui/components/staticPages/Pricing';
import { useFeatureToggleContext } from '@/Framework/UI/Organisms/FeatureToggle/Context';
import { CFR_REBRANDING } from '@finsight/config/featureToggle';

import styles from './Company.scss';

const pages = [
  {
    name: 'About',
    id: 'about-tab-id',
    path: URL.ABOUT,
    component: AboutUs,
    metaTitle: getPageTitle(metaTags.getAbout().title),
    metaDescription: metaTags.getAbout().description,
    metaSchema: getAboutPageMetaSchema(),
    withoutSchemaMerging: true,
  },
  {
    name: 'Market Data Pricing',
    id: 'pricing-tab-id',
    path: URL.PRICING,
    component: Pricing,
    metaTitle: getPageTitle(metaTags.getPricing().title),
    metaDescription: metaTags.getPricing().description,
    withoutSchemaMerging: true,
  },
  {
    name: 'Solutions',
    id: 'solutions-tab-id',
    path: URL.SOLUTIONS,
    component: OurSolutions,
    metaTitle: metaTags.getOurSolutions().title,
    metaDescription: metaTags.getOurSolutions().description,
    metaSchema: getSolutionPageMetaSchema(),
    withoutSchemaMerging: true,
  },
  {
    name: 'Careers',
    id: 'careers-tab-id',
    path: URL.CAREERS,
    component: Careers,
    metaTitle: metaTags.getCareers().title,
    metaDescription: metaTags.getCareers().description,
    metaSchema: getCareersPageMetaSchema(),
    withoutSchemaMerging: true,
  },
  {
    name: 'Contact',
    id: 'contact-tab-id',
    path: URL.CONTACT,
    component: ContactUs,
    metaTitle: getPageTitle(metaTags.getContactUs().title),
    metaDescription: metaTags.getContactUs().description,
    metaSchema: getContactUsPageMetaSchema(),
    withoutSchemaMerging: true,
  },
];

const Company = () => {
  const { getFeatureByName } = useFeatureToggleContext();
  const { isEnabled: isHidePricingPage } = getFeatureByName(CFR_REBRANDING);
  const filteredPages = isHidePricingPage
    ? pages.filter((page) => page.id !== 'pricing-tab-id')
    : pages;

  return (
    <StaticTemplate
      className={ styles.pageContainer }
      pages={ filteredPages }
    />
  );
};

export default Company;
